<template>
  <div class="d-flex flex-column ai-center">
    <div class="d-flex w-100 jc-end">
      <v-btn
        class="btn btn-update"
        color="primary"
        @click="updatePassword"
        depressed
        :disabled="!valid"
      >
        {{ $t("profile.updatePassword") }}
      </v-btn>
    </div>
    <v-form class="d-flex flex-column profile-form" v-model="valid">
      <label>{{ $t("profile.oldPassword") }}</label>
      <v-text-field
        v-model="member.password"
        background-color="#f8f8f8"
        color="#181C24"
        type="password"
        :rules="[rules.required, rules.validPwdLen, rules.validPwd]"
        solo
        flat
      ></v-text-field>
      <label>{{ $t("profile.newPassword") }}</label>
      <v-text-field
        v-model="member.newPassword"
        background-color="#f8f8f8"
        color="#181C24"
        type="password"
        :rules="[rules.required, rules.validPwdLen, rules.validPwd]"
        solo
        flat
      ></v-text-field>
      <label>{{ $t("profile.repeatPassword") }}</label>
      <v-text-field
        v-model="member.repeatPassword"
        background-color="#f8f8f8"
        color="#181C24"
        type="password"
        :rules="[rules.required, rules.repeatPwd]"
        solo
        flat
      ></v-text-field>
    </v-form>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      valid: false,
      invalidPwd: false,
      member: {
        password: "",
        newPassword: "",
        repeatPassword: ""
      },
      rules: {
        required: value => !!value || this.$t("errorMessage.required"),
        repeatPwd: value =>
          value === this.member.newPassword ||
          this.$t("errorMessage.repeatPassword"),
        validPwdLen: value =>
          /\S{6,30}$/.test(value) || this.$t("errorMessage.passwordLength"),
        validPwd: value =>
          /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)(?![\W_]+$)/.test(value) ||
          this.$t("errorMessage.passwordFormat")
      }
    };
  },
  methods: {
    ...mapActions("snackbar", ["openSnackbar"]),
    ...mapMutations("user", ["clearUser"]),
    async updatePassword() {
      await this.$http
        .put("members/updatepassword", this.member)
        .then(async () => {
          this.openSnackbar({
            msg: this.$t("profile.passwordUpdated"),
            color: "success"
          });
          await this.$http.post("signout");
          this.$cookies.remove("token");
          this.clearUser();
          this.$router.push(`/${this.$i18n.locale}`);
        });
    }
  }
};
</script>

<style lang="sass" scoped></style>
